import { FC, ReactNode } from 'react';

import Helmet from 'react-helmet';
import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import EmergencyBanner from '../../areas/Emergencies/HeaderBanner';
import { useAppSelector } from '../../hooks';
import _ from 'lodash';

export interface ApplicationProps {
  header?: ReactNode;
  footer?: ReactNode;
  showFooter?: boolean;
}

const Application: FC<ApplicationProps> = ({
  children,
  header,
  footer,
  showFooter = false,
}) => {
  const { hasEmergencies } = useAppSelector((store) => ({
    hasEmergencies: _.some(store.emergencies.data),
  }));

  return (
    <>
      <Helmet titleTemplate="Publista - %s" defaultTitle="Home" />

      <div>
        <EmergencyBanner emergencies={hasEmergencies} />
        <Header>{header}</Header>
        <Body footerShown={showFooter} emergenciesBanner={hasEmergencies}>
          {children}
        </Body>
        <Footer footerShown={showFooter}>{footer}</Footer>
      </div>
    </>
  );
};

export default Application;
